import styled, { css } from 'styled-components';

export const Box = styled.div`
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  border-radius: 8px;
  position: relative;
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  color: ${({ theme }) => theme.colors['neutral-100']};
  display: block;
  margin-bottom: 12px;
`;

export const Label = styled.label`
  cursor: pointer;
  color: ${({ theme }) => theme.colors['primary-60']};
  display: inline-flex;
  align-items: center;

  &[aria-disabled='true'] {
    pointer-events: none;
    opacity: 60%;
  }

  & > svg {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
`;

const fontSize = css`
  font-size: 14px;
  line-height: 150%;
`;

export const LabelText = styled.p`
  font-weight: 400;
  ${fontSize};
`;

export const Input = styled.input`
  display: none;
`;

export const UploadedBox = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors['neutral-80']};
  margin-bottom: 12px;
`;

export const Link = styled.a`
  display: inline-block;
  margin-left: 6px;
  ${fontSize}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 0;
  color: ${({ theme }) => theme.colors['primary-60']};

  & > svg {
    line-height: 21px;
    font-size: 12px;
    position: relative;
    top: 1px;
    margin-right: 6px;
  }
`;

export const DeleteButtonContainer = styled.div`
  margin-left: 16px;
  border-left: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  padding-left: 16px;
  flex-grow: 1;

  & svg {
    font-size: 14px;
    width: 14px;
  }
`;

export const UploadProgressContainer = styled.div`
  margin-top: 12px;
  width: 100%;
`;

export const ProgressText = styled.p`
  font-size: 12px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-70']};
  text-align: center;
  margin-top: 4px;
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-100']};
`;
